"use client";

import { useContext } from "react";
import Script from "next/script";
import { UserContext } from "@/contexts/user-context";
import { resolvePublicEnvValue } from "@/service/public-env";
import { useEnvContext } from "next-runtime-env";

export const Advertising = () => {
  const { isLoggedIn, isBusinessUser } = useContext(UserContext);
  const { NEXT_PUBLIC_FACEBOOK_PIXEL_ENABLED } = useEnvContext();

  return (
    <Script id={"cookies-advertising"} strategy={"afterInteractive"}>
      {`
  let isAdvertising = ${
    isLoggedIn || isBusinessUser ? `"1"` : "localStorage.getItem('advertising')"
  };
      
  if (isAdvertising === null) {
    localStorage.setItem('advertising', '0');
    isAdvertising = '0';
  }

  if (isAdvertising === '1' && isAccept === '1') {
    ${
      resolvePublicEnvValue(NEXT_PUBLIC_FACEBOOK_PIXEL_ENABLED)
        ? `
          !function (f, b, e, v, n, t, s) {
            if (f.fbq)
              return;
    
    
            n = f.fbq = function () {
              n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
            };
            if (!f._fbq)
              f._fbq = n;
    
    
            n.push = n;
            n.loaded = !0;
            n.version = '2.0';
            n.queue = [];
            t = b.createElement(e);
            t.async = !0;
            t.src = v;
            s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s)
          }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
        `
        : ""
    }
    }
      `}
    </Script>
  );
};
